import { debounceTime, filter, map, take } from 'rxjs/operators';
import { OrderBuilderState } from '../../../../../reducers';
import { getReceivingPersonEntities } from '@ordersnproducts/modules/shared/modules/receiving-person/redux/selectors/index';
import { IContact } from '@cemex-core/cmx-api/models/contact/contact';
import {
  ReceivingPersonsAddLocalContactAction,
  ReceivingPersonsSetAction,
} from '@ordersnproducts/modules/shared/modules/receiving-person/redux/actions/receiving-person.actions';
import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { UntypedFormGroup } from '@angular/forms';
import { getOrderSelectedDetailState as RepeatDetail } from '@ordersnproducts/modules/new-repeat-order/selectors/order-selected-detail.selector';
import { getOrderSelectedDetailState as ModifyDetail } from '@ordersnproducts/modules/new-modify-order/selectors/order-selected-detail.selector';
import { combineLatest } from 'rxjs';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';

@Injectable()
export class ReceivingPersonSetCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    if (value !== undefined) {
      this.store
        .select(getReceivingPersonEntities)
        .pipe(
          take(1),
          map((persons: IContact[]) => {
            return persons.find((person: IContact) => {
              return person.contactId === value;
            });
          }),
        )
        .subscribe((person: IContact) => {
          return this.store.dispatch(new ReceivingPersonsSetAction(person));
        });
    }
  }
}

/**
 * Validates available value in catalog input selection.
 * Adds original value to the combo selection if missing
 * For repeat and modify command US
 */
@Injectable()
export class ReceivingPersonCatalogValidation implements OnFieldChanged {
  constructor(
    private store: Store<OrderBuilderState>,
    private featureToggle: FeatureToggleService,
  ) {}
  private CloudContactModuleEnabled = this.featureToggle.isFeatureEnabled(Features.CLOUD_CONTACT_MODULE);
  onFieldChanged(
    value: number,
    formGroup: UntypedFormGroup,
    form: ConfigurableFormComponent,
    config: FieldConfig,
  ): void {
    if (value !== undefined) {
      this.store
        .select(getReceivingPersonEntities)
        .pipe(
          debounceTime(500),
          filter((persons) => !!value && persons.length > 0),
          take(1),
          map((persons: IContact[]) => {
            return persons.find((person: IContact) => {
              return person.contactId === value;
            });
          }),
        )
        .subscribe((person: IContact) => {
          if (!person) {
            combineLatest([this.store.select(RepeatDetail), this.store.select(ModifyDetail)])
              .pipe(
                filter(([repeatData, modifyData]) => !!repeatData.order || !!modifyData.order),
                take(1),
                map(([repeatData, modifyData]) => {
                  const orderDetail = !!repeatData.order ? repeatData.order : modifyData.order;
                  return orderDetail.contact;
                }),
              )
              .subscribe((receivingPerson) => {
                if (this.CloudContactModuleEnabled) {
                  formGroup.get(config.name).setValue(undefined);
                } else {
                  this.store.dispatch(
                    new ReceivingPersonsAddLocalContactAction({
                      contactId: receivingPerson.contactId,
                      name: receivingPerson.name || receivingPerson.contactName,
                      phone: receivingPerson.contactPhone,
                    }),
                  );
                }
              });
          }
        });
    }
  }
}
